<template>
  <PrimaryButton data-testid="confirm-fulfillment-slot" size="lg" justify="justify-center" @click="$emit('confirm')">
    Continue
  </PrimaryButton>
</template>

<script>
import PrimaryButton from '@/components/Molecules/PrimaryButton'

export default {
  name: 'ConfirmFulfillmentSlotButton',
  components: { PrimaryButton },
  emits: ['confirm']
}
</script>
